<template>
  <footer>
    <div class="gfooter">
      <div class="flogo">
        <a href="#scroll" v-smooth-scroll><img src="@/assets/img/client/logo.png" alt="GLOCALY"></a>
      </div>
      <div class="fnav" v-if="account">
        <ul>
          <li><router-link :to="{ name: 'Client Property List', params: { lang: currentlanguage } }">{{ $t('business-property') }}</router-link></li>
          <li><router-link :to="{ name: 'rental-property-list', params: { type: 'residential-property-list', lang: currentlanguage }}" v-html="$t('rental-residential-property')" /></li>
          <li><router-link :to="{ name: 'rental-property-list', params: { type: 'commercial-property-list', lang: currentlanguage }}" v-html="$t('rental-commercial-property')" /></li>
          <li><router-link :to="{ name: 'Client Blog List', params: { lang: currentlanguage } }">{{ $t('members_blog') }}</router-link></li>
          <li><router-link :to="{ name: 'Client Contact', params: { lang: currentlanguage } }" >{{ $t('contact') }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="gcopyright">
      <div class="gcopyright_inner">
        <div><p>Copyright &copy; LEAD-REAL ESTATE CO.LTD. <span class="ilB">All rights reserved.</span></p></div>
        <div>
          <ul>
            <li><a :href="'https://www.lead-real.co.jp/' + currentlanguageRoute + 'company/'" target="_blank">{{ $t('about_us') }}</a></li>
            <li><a :href="'https://www.lead-real.co.jp/' + currentlanguageRoute + 'service/'" target="_blank">{{ $t('descr_business') }}</a></li>
            <li><a :href="'https://www.lead-real.co.jp/' + currentlanguageRoute + 'privacy/'" target="_blank">{{ $t('privacy_policy') }}</a></li>
            </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    let language = this.$route.params.lang
    if (!language) language = Vue.$cookies.get('language')

    return {
      currentlanguage: language,
      account: Vue.$cookies.get('account')
    }
  },
  created () {
    const ckeditor = document.createElement('script'); ckeditor.setAttribute('src', '/google.js')
    document.head.appendChild(ckeditor)
  },
  computed: {
    currentlanguageRoute () {
      if (this.currentlanguage === 'zh-cn') {
        return 'zh/'
      } else if (this.currentlanguage === 'ja') {
        return ''
      }
      return this.currentlanguage + '/'
    }
  },
  methods: {
    home: function () {
      this.$router.push({ name: 'Client Property' }).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
    }
  }
}
</script>
